import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();

reportWebVitals(({ name, value, id }) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, {
    event_category: 'web-vitals',
    value: Math.round(name === 'CLS' ? value * 1000 : value),
    metric_id: id,
    non_interaction: true,
  });
});
